import { getSupportedSearchParamFromUrl } from "@utils/helpers/getSupportedSearchParamFromUrl";
import { SupportedSearchParam, PartnerId } from "@utils/types";

export const getPartnerIdFromUrl = (): PartnerId => {
  const partnerIdFromUrl = getSupportedSearchParamFromUrl(SupportedSearchParam.partnerId);
  const partnerIds = Object.values(PartnerId);
  const partnerId = partnerIds.find((id) => id === partnerIdFromUrl);
  return partnerId ?? PartnerId.None;
};
